import { render, staticRenderFns } from "./accountWithdrawalApplyManage.vue?vue&type=template&id=0b1f479b&scoped=true"
import script from "./accountWithdrawalApplyManage.vue?vue&type=script&lang=js"
export * from "./accountWithdrawalApplyManage.vue?vue&type=script&lang=js"
import style0 from "./accountWithdrawalApplyManage.vue?vue&type=style&index=0&id=0b1f479b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1f479b",
  null
  
)

export default component.exports